/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Money_Art_1_DetailInputs */

const en_services_svc_money_art_1_detail = /** @type {(inputs: Services_Svc_Money_Art_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matches your market and size`)
};

const lv_services_svc_money_art_1_detail = /** @type {(inputs: Services_Svc_Money_Art_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbilst Jūsu tirgum un izmēram`)
};

/**
* | output |
* | --- |
* | "Matches your market and size" |
*
* @param {Services_Svc_Money_Art_1_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_money_art_1_detail = /** @type {((inputs?: Services_Svc_Money_Art_1_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Money_Art_1_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_money_art_1_detail(inputs)
	return en_services_svc_money_art_1_detail(inputs)
});